var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 6.7C17.3866 6.7 17.7 6.3866 17.7 6C17.7 5.6134 17.3866 5.3 17 5.3L17 6.7ZM0.505026 5.50502C0.231659 5.77839 0.231659 6.22161 0.505026 6.49497L4.9598 10.9497C5.23316 11.2231 5.67638 11.2231 5.94975 10.9497C6.22311 10.6764 6.22311 10.2332 5.94975 9.9598L1.98995 6L5.94975 2.0402C6.22311 1.76683 6.22311 1.32362 5.94975 1.05025C5.67638 0.776885 5.23317 0.776884 4.9598 1.05025L0.505026 5.50502ZM17 5.3L1 5.3L1 6.7L17 6.7L17 5.3Z","fill":"currentColor"}));
}

ArrowLeft.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
